import CONFIG from '../config';

export default function useClientConfigs() {
  return window.__TBX_ENV__.TBX_IDP_CLIENT &&
    Object.keys(CONFIG.settings).includes(window.__TBX_ENV__.TBX_IDP_CLIENT)
    ? CONFIG.settings[window.__TBX_ENV__.TBX_IDP_CLIENT]
    : CONFIG.settings.default;
}
